import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { DistrictService } from '../district.service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-district-register',
  templateUrl: './district-register.component.html',
  styleUrls: ['./district-register.component.scss']
})
export class DistrictRegisterComponent implements OnInit {
  district_register_form: FormGroup;
  action: string = '';
  states = [];
  constructor(private formBuilder: FormBuilder, private service : DistrictService, private http: HttpService, private global: GlobalService) { 
    this.getStates();
    this.district_register_form = this.formBuilder.group({
      id: [null, Validators.compose([])],
      name: [null, Validators.compose([Validators.required])],
      state_id: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      capital: [null, Validators.compose([Validators.required])],
    })

    if (this.service.get_district_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.setupUpdateForm(this.service.get_district_data);
    }

    this.service.DistrictUpdate.subscribe((relation_data) => {
      if (relation_data === null) {
        this.action = 'register';
        this.district_register_form.reset();
      } else {
        this.action = 'update';
        this.setupUpdateForm(relation_data);
      }
    });

    this.service.DistrictUpdate.subscribe((relation_type) => {
      this.setupUpdateForm(relation_type);
    });

  }


  getStates() {
    this.http.getStates().subscribe((data: []) => {
      console.log(data);
      this.states = data;
    }, (error) => {
      console.log(error);
    });
  }

   setupUpdateForm(district) {
    this.district_register_form.controls['id'].setValue(district['id']);
    this.district_register_form.controls['name'].setValue(district['name']);
    this.district_register_form.controls['state_id'].setValue(district['state_id']);
    this.district_register_form.controls['code'].setValue(district['code']);
    this.district_register_form.controls['capital'].setValue(district['capital']);
   }

   registerDistrict() {
    const taluk_data = Object.assign({}, this.district_register_form.value);
    console.log(taluk_data)
    this.http.saveDistrict(taluk_data).subscribe((data) => {
      this.global.showSnakeBar(data['message']);
      this.district_register_form.reset();
      this.service.downloadDistrict.emit(true);
    });
  }
  ngOnInit() {
  }

}
